module.exports = __webpack_public_path__ + "img/toggles.98ae0ccb.svg";